(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelectorAll('.kronox-footer__localization select').forEach((select) => {
    if (select.dataset.localizationReady === 'true') return;

    select.querySelectorAll('option[data-country-code]').forEach((option) => {
      const countryCode = option.dataset.countryCode?.toUpperCase();
      if (!countryCode || countryCode.length !== 2) return;

      const flag = String.fromCodePoint(
        ...countryCode.split('').map((character) => 127397 + character.charCodeAt(0))
      );
      option.textContent = `${flag}  ${option.textContent.trim()}`;
    });

    select.dataset.localizationReady = 'true';
    select.addEventListener('change', () => select.form.requestSubmit());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kronox-product-info-dawn"] && !Shopify.designMode) return;
  try {
    
  class KronoxProductInfo {
    constructor(section) {
      this.section = section;
      this.form = section.querySelector('.kpx-product__form');
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.variantInput = section.querySelector('[data-kpx-variant-input]');
      this.currentPrice = section.querySelector('[data-kpx-current-price]');
      this.comparePrice = section.querySelector('[data-kpx-compare-price]');
      this.saveBadge = section.querySelector('[data-kpx-save-badge]');
      this.addButton = section.querySelector('[data-kpx-add]');
      this.addText = section.querySelector('[data-kpx-add-text]');
      this.stickyBar = section.querySelector('[data-kpx-sticky-atc]');
      this.stickyButton = section.querySelector('[data-kpx-sticky-add]');
      this.stickyPrice = section.querySelector('[data-kpx-sticky-price]');
      this.stickyPack = section.querySelector('[data-kpx-sticky-pack]');
      this.stickyAddText = section.querySelector('[data-kpx-sticky-add-text]');
      this.valueTrigger = section.querySelector('[data-kpx-value-open]');
      this.valueDialog = section.querySelector('[data-kpx-value-dialog]');
      this.valueRows = section.querySelector('[data-kpx-value-rows]');
      this.activeCartCurrency = section.dataset.cartCurrencyCode || '';
      this.syncCurrencyFromText(section.dataset.cartMoneyProbe || '');
      if (this.cart && this.addButton) this.addButton.setAttribute('aria-haspopup', 'dialog');
      this.media = this.parseMedia();
      this.bindEvents();
      this.bindHeaderCartTriggers();
      this.initStickyAtc();
      this.updateValueBreakdown(this.section.querySelector('[data-kpx-card].is-selected'));
      setTimeout(() => this.enhanceCartDrawer(), 0);
    }

    parseMedia() {
      const mediaScript = this.section.querySelector('[data-kpx-media-json]');
      if (!mediaScript) return {};
      try {
        return JSON.parse(mediaScript.textContent);
      } catch (error) {
        return {};
      }
    }

    bindEvents() {
      this.section.querySelectorAll('[data-kpx-card]').forEach((card) => {
        card.addEventListener('click', () => this.selectVariant(card));
      });
      this.section.querySelectorAll('[data-kpx-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => this.selectMedia(thumb.dataset.mediaId));
      });
      const mobileMedia = this.section.querySelector('[data-kpx-mobile-media]');
      if (mobileMedia) {
        let mobileMediaFrame = null;
        mobileMedia.addEventListener('scroll', () => {
          if (mobileMediaFrame) return;
          mobileMediaFrame = window.requestAnimationFrame(() => {
            mobileMediaFrame = null;
            this.syncMobileMediaThumb(mobileMedia);
          });
        }, { passive: true });
      }
      if (this.form) this.form.addEventListener('submit', (event) => this.addToCart(event));
      if (this.stickyButton) {
        this.stickyButton.addEventListener('click', () => {
          if (this.addButton && !this.addButton.disabled && this.addButton.getAttribute('aria-disabled') !== 'true') {
            this.addButton.click();
          }
        });
      }
      const valueOpen = this.section.querySelector('[data-kpx-value-open]');
      const valueClose = this.section.querySelector('[data-kpx-value-close]');
      const valueCta = this.section.querySelector('[data-kpx-value-cta]');
      if (valueOpen && this.valueDialog) {
        valueOpen.addEventListener('click', () => {
          this.updateValueBreakdown(this.section.querySelector('[data-kpx-card].is-selected'));
          this.valueDialog.showModal();
        });
      }
      if (valueClose && this.valueDialog) valueClose.addEventListener('click', () => this.valueDialog.close());
      if (valueCta && this.valueDialog) {
        valueCta.addEventListener('click', () => {
          this.valueDialog.close();
          if (this.addButton && !this.addButton.disabled) this.addButton.click();
        });
      }
      if (this.valueDialog) {
        this.valueDialog.addEventListener('click', (event) => {
          if (event.target === this.valueDialog) this.valueDialog.close();
        });
      }
    }

    updateValueBreakdown(card) {
      if (!this.valueDialog || !this.valueRows || !card) return;

      const packIndex = Number(card.dataset.packIndex || 1);
      if (this.valueTrigger) this.valueTrigger.hidden = packIndex === 1;
      const multiplier = packIndex === 3 ? 2 : 1;
      const allItems = [
        { label: 'AlpineX Smartwatch', quantity: 1, unitUsdCents: 12995 },
        { label: 'Premium straps', quantity: 2, unitUsdCents: 2495 },
        { label: 'Everyday straps', quantity: 6, unitUsdCents: 1495 },
        { label: 'Screen protector', quantity: 1, unitUsdCents: 1495 },
        { label: 'Extra charging cable', quantity: 1, unitUsdCents: 1495 },
      ];
      const items = packIndex === 1 ? allItems.slice(0, 1) : allItems;
      const rate = this.localCurrencyRate();
      const localizeUsdCents = (usdCents) => Math.round(usdCents * rate);
      const packPriceCents = Number(card.dataset.priceCents || 0);
      const compareAtCents = Number(card.dataset.comparePriceCents || 0);
      const savingsCents = Math.max(0, compareAtCents - packPriceCents);
      const title = card.querySelector('.kpx-product__pack-title')?.textContent?.trim() || 'Selected pack';

      this.valueRows.innerHTML = items.map((item) => {
        const quantity = item.quantity * multiplier;
        const unitPrice = this.formatCartMoney(localizeUsdCents(item.unitUsdCents));
        const linePrice = this.formatCartMoney(localizeUsdCents(item.unitUsdCents * quantity));
        const quantityMarkup = quantity > 1 ? `<small>${quantity} × ${unitPrice}</small>` : '';
        return `<div class="kpx-product__value-row" role="row"><span role="rowheader">${this.escapeHtml(item.label)}${quantityMarkup}</span><span>${linePrice}</span></div>`;
      }).join('');

      const titleNode = this.valueDialog.querySelector('[data-kpx-value-title]');
      const retailNode = this.valueDialog.querySelector('[data-kpx-value-retail]');
      const priceNode = this.valueDialog.querySelector('[data-kpx-value-price]');
      const savingNode = this.valueDialog.querySelector('[data-kpx-value-saving]');
      if (titleNode) titleNode.textContent = `${title} value`;
      if (retailNode) retailNode.textContent = `Over ${this.formatWholeCartMoney(compareAtCents)}`;
      if (priceNode) priceNode.textContent = this.formatCartMoney(packPriceCents);
      if (savingNode) savingNode.textContent = this.formatCartMoney(savingsCents);
    }

    localCurrencyRate() {
      const shopCurrency = this.section.dataset.shopCurrency || 'USD';
      const activeCurrency = this.cartCurrencyCode();
      if (shopCurrency === activeCurrency) return 1;
      const rate = Number(window.Shopify?.currency?.rate || 0);
      return rate > 0 ? rate : 1;
    }

    formatWholeCartMoney(cents) {
      const value = Math.floor(Number(cents || 0) / 100);
      const currency = this.cartCurrencyCode();
      try {
        return new Intl.NumberFormat(this.cartLocale(), {
          style: 'currency',
          currency,
          currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(value);
      } catch (error) {
        return `${currency} ${value}`;
      }
    }

    initStickyAtc() {
      if (!this.stickyBar || !this.addButton) return;

      const update = () => {
        const addRect = this.addButton.getBoundingClientRect();
        const footer = document.querySelector('.kronox-footer');
        const footerIsVisible = footer && footer.getBoundingClientRect().top < window.innerHeight;
        const shouldShow = addRect.bottom < 0 && !footerIsVisible;

        this.stickyBar.hidden = false;
        this.stickyBar.classList.toggle('is-visible', shouldShow);
        this.stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      };

      update();
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    }

    bindHeaderCartTriggers() {
      if (window.kpxCartLinkDrawerBound) {
        document.addEventListener('kpx:cart-drawer-opened', () => this.enhanceCartDrawer());
        return;
      }

      if (window.kpxHeaderCartTriggersBound) return;
      window.kpxHeaderCartTriggersBound = true;

      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('a[href]');
        if (!trigger || trigger.closest('cart-drawer')) return;

        let url;
        try {
          url = new URL(trigger.getAttribute('href'), window.location.origin);
        } catch (error) {
          return;
        }

        if (url.pathname.replace(/\/$/, '') !== '/cart') return;

        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return;

        event.preventDefault();
        drawer.classList.remove('is-empty');

        if (typeof drawer.open === 'function') {
          drawer.open(trigger);
        } else {
          drawer.classList.add('active');
          document.body.classList.add('overflow-hidden');
        }

        setTimeout(() => this.enhanceCartDrawer(), 80);
      });
    }

    addToCart(event) {
      event.preventDefault();
      if (!this.form || !this.addButton || this.addButton.disabled || this.addButton.getAttribute('aria-disabled') === 'true') return;

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.addButton.setAttribute('aria-disabled', 'true');
      this.addButton.classList.add('is-loading');
      if (this.stickyButton) this.stickyButton.disabled = true;

      const config = typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/json' } };

      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!formData.get('quantity')) formData.append('quantity', '1');

      if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        if (typeof this.cart.setActiveElement === 'function') this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      fetch(window.routes?.cart_add_url || '/cart/add.js', config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) throw new Error(response.description || response.message || 'Add to cart failed');

          if (!this.cart || typeof this.cart.renderContents !== 'function') {
            window.location = window.routes?.cart_url || '/cart';
            return;
          }

          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'kronox-product-info',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          }

          this.cart.renderContents(response);
          setTimeout(() => this.enhanceCartDrawer(), 80);
        })
        .catch((error) => {
          console.error(error);
          window.location = window.routes?.cart_url || '/cart';
        })
        .finally(() => {
          this.addButton.classList.remove('is-loading');
          if (!this.addButton.disabled) this.addButton.removeAttribute('aria-disabled');
          const selectedCard = this.section.querySelector('[data-kpx-card].is-selected');
          const selectedAvailable = selectedCard ? selectedCard.dataset.available === 'true' : !this.addButton.disabled;
          if (this.stickyButton) this.stickyButton.disabled = !selectedAvailable;
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        });
    }

    selectVariant(card) {
      this.section.querySelectorAll('[data-kpx-card]').forEach((item) => {
        const selected = item === card;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-checked', selected ? 'true' : 'false');
      });

      if (this.variantInput) {
        this.variantInput.value = card.dataset.variantId;
        this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (this.currentPrice) this.currentPrice.textContent = card.dataset.price;

      const hasDiscount = card.dataset.hasDiscount === 'true';
      if (this.comparePrice) {
        this.comparePrice.textContent = card.dataset.comparePrice;
        this.comparePrice.classList.toggle('is-hidden', !hasDiscount);
      }
      if (this.saveBadge) {
        const label = this.section.dataset.saveLabel || 'Save';
        this.saveBadge.textContent = `${label} ${card.dataset.savings}`;
        this.saveBadge.classList.toggle('is-hidden', !hasDiscount);
      }

      const available = card.dataset.available === 'true';
      if (this.addButton) this.addButton.disabled = !available;
      if (this.addText) this.addText.textContent = available ? (this.section.dataset.addLabel || 'Add to cart') : (this.section.dataset.soldOutLabel || 'Sold out');
      if (this.stickyButton) this.stickyButton.disabled = !available;
      if (this.stickyAddText) this.stickyAddText.textContent = available ? (this.section.dataset.addLabel || 'Add to cart') : (this.section.dataset.soldOutLabel || 'Sold out');
      if (this.stickyPrice) this.stickyPrice.textContent = card.dataset.price;
      if (this.stickyPack) this.stickyPack.textContent = card.querySelector('.kpx-product__pack-title')?.textContent?.trim() || '';
      this.updateValueBreakdown(card);
      if (card.dataset.mediaId) this.selectMedia(card.dataset.mediaId);
    }

    selectMedia(mediaId) {
      const media = this.media[mediaId];
      const main = this.section.querySelector('[data-kpx-main-media]');
      if (!media || !media.image) return;
      if (main) {
        main.innerHTML = `<img src="${media.image}" alt="${this.escapeHtml(media.alt || '')}" class="kpx-product__main-image" loading="eager">`;
      }
      this.section.querySelectorAll('[data-kpx-thumb]').forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb.dataset.mediaId === mediaId);
      });
      const mobileSlide = Array.from(this.section.querySelectorAll('[data-kpx-mobile-slide]')).find((slide) => slide.dataset.mediaId === String(mediaId));
      if (mobileSlide) {
        const mobileTrack = mobileSlide.closest('[data-kpx-mobile-media]');
        if (mobileTrack) {
          mobileTrack.scrollTo({
            left: mobileSlide.offsetLeft - mobileTrack.offsetLeft,
            behavior: 'smooth'
          });
        }
      }
    }

    syncMobileMediaThumb(track) {
      const slides = Array.from(track.querySelectorAll('[data-kpx-mobile-slide]'));
      if (!slides.length) return;

      const activeSlide = slides.reduce((closest, slide) => {
        const distance = Math.abs(slide.offsetLeft - track.scrollLeft);
        return !closest || distance < closest.distance ? { slide, distance } : closest;
      }, null)?.slide;

      const mediaId = activeSlide?.dataset.mediaId;
      if (!mediaId) return;

      this.section.querySelectorAll('[data-kpx-thumb]').forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb.dataset.mediaId === mediaId);
      });
    }

    enhanceCartDrawer() {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      drawer.classList.add('kpx-cart');
      const inner = drawer.querySelector('.drawer__inner');
      if (!inner) return;

      const header = inner.querySelector('.drawer__header');
      const timerMarkup = '<div class="kpx-cart__timer"><span>Your order is reserved for</span><strong data-kpx-cart-timer>10:00</strong></div>';
      const confirmMarkup = '<div class="kpx-cart__confirm"><i aria-hidden="true"></i><span>Added to cart</span></div>';

      const footer = inner.querySelector('.drawer__footer');
      if (footer) {
        this.syncCurrencyFromDrawer(drawer);
        const currentStack = inner.querySelector('.kpx-cart__stack');
        const addonsSignature = this.cartAddonsSignature();
        if (!currentStack) {
          footer.insertAdjacentHTML('beforebegin', this.cartDrawerModules(addonsSignature));
        } else if (currentStack.dataset.addonsSignature !== addonsSignature) {
          currentStack.outerHTML = this.cartDrawerModules(addonsSignature);
        }
      }

      const stack = inner.querySelector('.kpx-cart__stack');
      if (header) {
        header.querySelectorAll('.kpx-cart__confirm').forEach((element) => element.remove());
        const closeButton = header.querySelector('.drawer__close');
        const timer = header.querySelector('.kpx-cart__timer') || stack?.querySelector('.kpx-cart__timer') || inner.querySelector('.kpx-cart__timer');
        if (timer && !header.contains(timer)) {
          if (closeButton) {
            closeButton.insertAdjacentElement('beforebegin', timer);
          } else {
            header.appendChild(timer);
          }
        } else if (!timer) {
          if (closeButton) {
            closeButton.insertAdjacentHTML('beforebegin', timerMarkup);
          } else {
            header.insertAdjacentHTML('beforeend', timerMarkup);
          }
        }
      }
      if (stack) {
        const confirm = stack.querySelector('.kpx-cart__confirm') || inner.querySelector('.kpx-cart__confirm');
        if (confirm && !stack.contains(confirm)) {
          stack.insertBefore(confirm, stack.firstElementChild);
        } else if (!confirm) {
          stack.insertAdjacentHTML('afterbegin', confirmMarkup);
        }
      }
      this.startCartTimer();

      this.bindCartDrawerActions(drawer);
      this.updateCartDrawerFooter();
      this.updateCartDrawerItems();
    }

    bindCartDrawerActions(drawer) {
      if (!drawer || drawer.dataset.kpxActionsBound === 'true') return;
      drawer.dataset.kpxActionsBound = 'true';

      drawer.addEventListener('click', (event) => {
        const removeButton = event.target.closest('[data-kpx-cart-remove]');
        if (removeButton) {
          event.preventDefault();
          this.removeCartItem(removeButton);
          return;
        }

        const offerButton = event.target.closest('[data-kpx-cart-offer]');
        if (offerButton) {
          event.preventDefault();
          if (offerButton.hasAttribute('data-kpx-pack-upgrade')) {
            this.upgradeCartPack(offerButton);
          } else {
            this.addCartDrawerOffer(offerButton);
          }
          return;
        }

        const addonDot = event.target.closest('[data-kpx-addon-dot]');
        if (addonDot) {
          event.preventDefault();
          this.scrollCartAddonPage(addonDot);
        }
      });
    }

    expireCartTimer() {
      window.kpxCartTimerExpired = true;
      if (window.kpxCartTimerInterval) {
        clearInterval(window.kpxCartTimerInterval);
        window.kpxCartTimerInterval = null;
      }

      document.querySelectorAll('.kpx-cart__timer').forEach((timerWrap) => {
        timerWrap.classList.add('is-expired');
        const timer = timerWrap.querySelector('[data-kpx-cart-timer]');
        if (timer) timer.textContent = 'Reservation expired';
      });
    }

    startCartTimer() {
      if (window.kpxCartTimerExpired) {
        this.expireCartTimer();
        return;
      }
      if (window.kpxCartTimerStarted) return;
      window.kpxCartTimerStarted = true;
      window.kpxCartTimerEndsAt = Date.now() + 10 * 60 * 1000;

      const tick = () => {
        const remaining = Math.max(0, window.kpxCartTimerEndsAt - Date.now());
        if (remaining <= 0) {
          this.expireCartTimer();
          return;
        }
        const minutes = Math.floor(remaining / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        document.querySelectorAll('[data-kpx-cart-timer]').forEach((timer) => {
          timer.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        });
      };

      tick();
      window.kpxCartTimerInterval = setInterval(tick, 1000);
    }

    updateCartDrawerItems() {
      const holder = document.querySelector('[data-kpx-cart-items]');
      if (!holder) return;

      fetch(`${window.routes?.cart_url || '/cart'}.js`)
        .then((response) => response.json())
        .then((cart) => {
          this.syncCartCurrency(cart);
          const items = cart.items || [];
          if (!items.length) {
            holder.innerHTML = '';
            this.setCartDrawerEmptyState(true);
            this.updateCartDrawerFooter(cart);
            return;
          }

          this.setCartDrawerEmptyState(false);
          holder.innerHTML = items.slice(0, 3).map((item, index) => this.cartItemMarkup(item, index + 1)).join('');
          this.updateCartDrawerFooter(cart);
        })
        .catch(() => {});
    }

    setCartDrawerEmptyState(isEmpty) {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      const stack = drawer.querySelector('.kpx-cart__stack');
      const empty = drawer.querySelector('[data-kpx-cart-empty]');
      const footer = drawer.querySelector('.drawer__footer');
      const confirm = drawer.querySelector('.kpx-cart__confirm');
      const timer = drawer.querySelector('.kpx-cart__timer');
      const modules = drawer.querySelectorAll('[data-kpx-priority-progress], [data-kpx-upgrade], [data-kpx-cross-sell], .kpx-cart__trust');

      if (stack) stack.classList.toggle('is-empty', isEmpty);
      if (empty) empty.hidden = !isEmpty;
      if (footer) footer.hidden = isEmpty;
      if (confirm) confirm.hidden = isEmpty;
      if (timer) timer.hidden = isEmpty;
      modules.forEach((module) => {
        module.hidden = isEmpty || module.hidden && module.hasAttribute('data-kpx-upgrade');
      });
    }

    cartItemMarkup(item, line) {
      const image = item.image ? `<img src="${item.image}" alt="${this.escapeHtml(item.product_title || item.title)}" class="kpx-cart__item-img" loading="lazy">` : '<div class="kpx-cart__item-img"></div>';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : 'Selected pack';
      const price = this.formatCartMoney(item.final_line_price || item.line_price || item.price);

      return `
        <div class="kpx-cart__panel kpx-cart__item" data-kpx-cart-line="${line}">
          ${image}
          <div class="kpx-cart__item-copy">
            <strong>${this.escapeHtml(item.product_title || item.title)}</strong>
            <span>${this.escapeHtml(variant)}</span>
          </div>
          <div class="kpx-cart__item-meta">
            <span class="kpx-cart__item-price">${price}</span>
            <span class="kpx-cart__item-qty">Qty ${item.quantity}</span>
            <button type="button" class="kpx-cart__item-remove" data-kpx-cart-remove data-line="${line}" aria-label="Remove ${this.escapeHtml(item.product_title || item.title)}">Remove</button>
          </div>
        </div>
      `;
    }

    removeCartItem(button) {
      if (!button || button.disabled) return;
      const line = Number(button.dataset.line);
      if (!line) return;

      button.disabled = true;
      button.textContent = 'Removing...';
      this.cart = document.querySelector('cart-drawer');

      const payload = {
        line,
        quantity: 0,
      };

      if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
        payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
        payload.sections_url = window.location.pathname;
        if (typeof this.cart.setActiveElement === 'function') this.cart.setActiveElement(button);
      }

      fetch(window.routes?.cart_change_url || '/cart/change.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) throw new Error(response.description || response.message || 'Cart update failed');

          if (this.cart && typeof this.cart.renderContents === 'function' && response.sections) {
            this.cart.renderContents(response);
          }

          setTimeout(() => {
            this.enhanceCartDrawer();
            this.updateCartDrawerItems();
          }, 80);
        })
        .catch((error) => {
          console.error(error);
          button.disabled = false;
          button.textContent = 'Remove';
        });
    }

    addCartDrawerOffer(button) {
      if (!button || button.disabled) return;
      const variantId = button.dataset.variantId;
      if (!variantId) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = '+';

      const payload = {
        id: variantId,
        quantity: 1,
      };

      this.cart = document.querySelector('cart-drawer');
      if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
        payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
        payload.sections_url = window.location.pathname;
        if (typeof this.cart.setActiveElement === 'function') this.cart.setActiveElement(button);
      }

      fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) throw new Error(response.description || response.message || 'Add to cart failed');

          if (this.cart && typeof this.cart.renderContents === 'function' && response.sections) {
            this.cart.renderContents(response);
          }

          setTimeout(() => {
            this.enhanceCartDrawer();
            this.updateCartDrawerItems();
          }, 80);
        })
        .catch((error) => {
          console.error(error);
          button.disabled = false;
          button.textContent = originalText;
        });
    }

    updateCartDrawerFooter(cart) {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      this.syncCartCurrency(cart);

      if (cart && !Number(cart.item_count || 0)) {
        this.setCartDrawerEmptyState(true);
        return;
      }

      if (cart) this.setCartDrawerEmptyState(false);

      const checkoutButton = drawer.querySelector('.cart__checkout-button');
      if (checkoutButton) checkoutButton.textContent = 'Checkout';

      const footer = drawer.querySelector('.drawer__footer');
      const totals = footer?.querySelector('.totals');
      if (!footer || !totals) return;
      this.syncCurrencyFromDrawer(drawer);

      let savings = 0;
      if (cart) {
        savings = Number(cart.total_discount || 0);
        if (Array.isArray(cart.items)) {
          const variantCompareSavings = cart.items.reduce((total, item) => {
            const variantCard = this.section.querySelector(`[data-kpx-card][data-variant-id="${item.variant_id}"]`);
            if (!variantCard) return total;
            const price = Number(variantCard.dataset.priceCents || 0);
            const compare = Number(variantCard.dataset.comparePriceCents || 0);
            return total + Math.max(0, compare - price) * Number(item.quantity || 1);
          }, 0);
          savings = Math.max(savings, variantCompareSavings);
        }
        if (!savings && typeof cart.original_total_price === 'number' && typeof cart.total_price === 'number') {
          savings = Math.max(0, cart.original_total_price - cart.total_price);
        }
        if (!savings && Array.isArray(cart.items)) {
          savings = cart.items.reduce((total, item) => {
            const original = Number(item.original_line_price || item.line_price || 0);
            const final = Number(item.final_line_price || item.line_price || 0);
            return total + Math.max(0, original - final);
          }, 0);
        }
      }

      let savingsRow = footer.querySelector('[data-kpx-cart-savings]');
      if (!savingsRow) {
        totals.insertAdjacentHTML('afterend', `<div class="kpx-cart__savings" data-kpx-cart-savings><span>Total savings</span><strong>${this.formatCartMoney(0)}</strong></div>`);
        savingsRow = footer.querySelector('[data-kpx-cart-savings]');
      }

      const savingsValue = savingsRow.querySelector('strong');
      if (savingsValue) savingsValue.textContent = this.formatCartMoney(savings);

      this.updatePriorityProgress(cart);
      this.updateUpgradeOffer(cart);
      this.updateCartAddons(cart);
    }

    getPackVariants() {
      return Array.from(this.section.querySelectorAll('[data-kpx-card]')).slice(0, 3).map((card) => ({
        id: String(card.dataset.variantId || ''),
        title: card.querySelector('.kpx-product__pack-title')?.textContent?.trim() || 'Pack',
        price: Number(card.dataset.priceCents || 0),
      })).filter((variant) => variant.id);
    }

    updateUpgradeOffer(cart) {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      const upgrade = drawer.querySelector('[data-kpx-upgrade]');
      if (!upgrade) return;

      const button = upgrade.querySelector('[data-kpx-pack-upgrade]');
      const title = upgrade.querySelector('[data-kpx-upgrade-title]');
      const text = upgrade.querySelector('[data-kpx-upgrade-text]');
      const price = upgrade.querySelector('[data-kpx-upgrade-price]');
      const items = cart?.items || [];
      const variants = this.getPackVariants();

      if (variants.length < 2 || !items.length) {
        upgrade.hidden = true;
        return;
      }

      const variantIds = variants.map((variant) => variant.id);
      const highestPackIndex = items.reduce((highest, item) => {
        const index = variantIds.indexOf(String(item.variant_id));
        return index > highest ? index : highest;
      }, -1);

      if (highestPackIndex < 0 || highestPackIndex >= variants.length - 1) {
        upgrade.hidden = true;
        return;
      }

      const current = variants[highestPackIndex];
      const target = variants[highestPackIndex + 1];
      const line = items.findIndex((item) => String(item.variant_id) === current.id) + 1;
      const item = items[line - 1];
      const quantity = Number(item?.quantity || 1);
      const upgradeAmount = Math.max(0, (target.price - current.price) * quantity);

      upgrade.hidden = false;
      if (title) title.textContent = `Unlock the ${target.title}`;
      if (text) {
        text.textContent = highestPackIndex === 0
          ? 'Get the straps and protection customers usually add later, now for less.'
          : 'Get a second full setup for gifting, backup, or sharing while the offer is active.';
      }
      if (price) price.textContent = upgradeAmount > 0 ? `Upgrade for ${this.formatCartMoney(upgradeAmount)}` : 'Upgrade now';
      if (button) {
        button.disabled = !line || !target.id;
        button.dataset.sourceLine = String(line);
        button.dataset.variantId = target.id;
        button.dataset.quantity = String(quantity);
        button.textContent = 'Upgrade';
      }
    }

    upgradeCartPack(button) {
      if (!button || button.disabled) return;

      const sourceLine = Number(button.dataset.sourceLine || 0);
      const targetVariantId = button.dataset.variantId;
      const quantity = Math.max(1, Number(button.dataset.quantity || 1));
      if (!sourceLine || !targetVariantId) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Upgrading...';
      this.cart = document.querySelector('cart-drawer');

      fetch(window.routes?.cart_change_url || '/cart/change.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ line: sourceLine, quantity: 0 }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) throw new Error(response.description || response.message || 'Cart update failed');

          const payload = {
            id: targetVariantId,
            quantity,
          };

          if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
            payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
            if (typeof this.cart.setActiveElement === 'function') this.cart.setActiveElement(button);
          }

          return fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          });
        })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) throw new Error(response.description || response.message || 'Add to cart failed');

          if (this.cart && typeof this.cart.renderContents === 'function' && response.sections) {
            this.cart.renderContents(response);
          }

          setTimeout(() => {
            this.enhanceCartDrawer();
            this.updateCartDrawerItems();
          }, 80);
        })
        .catch((error) => {
          console.error(error);
          button.disabled = false;
          button.textContent = originalText;
        });
    }

    updatePriorityProgress(cart) {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      const progress = drawer.querySelector('[data-kpx-priority-progress]');
      if (!progress) return;

      const threshold = Number(this.section.dataset.cartPriorityThreshold || 0);
      const total = Number(cart?.total_price || 0);
      const remaining = Math.max(0, threshold - total);
      const percent = threshold > 0 ? Math.min(100, Math.round((total / threshold) * 100)) : 100;
      const isUnlocked = threshold > 0 && total >= threshold;

      const title = progress.querySelector('[data-kpx-priority-title]');
      const text = progress.querySelector('[data-kpx-priority-text]');
      const bar = progress.querySelector('[data-kpx-priority-bar]');
      const milestones = progress.querySelectorAll('[data-kpx-priority-milestone]');

      if (title) title.textContent = isUnlocked ? 'Priority processing unlocked' : 'Priority processing progress';
      if (text) {
        text.textContent = isUnlocked
          ? 'Your order now qualifies for priority processing.'
          : `You are ${this.formatCartMoney(remaining)} away from free priority processing.`;
      }
      if (bar) bar.style.width = `${percent}%`;

      milestones.forEach((milestone, index) => {
        const active = index === 0 || percent >= 50 && index === 1 || isUnlocked && index === 2;
        milestone.classList.toggle('is-active', active);
        milestone.classList.toggle('is-unlocked', isUnlocked && index === 2);
      });
    }

    formatCartMoney(cents) {
      const value = Number(cents || 0) / 100;
      const currency = this.cartCurrencyCode();
      const locale = this.cartLocale();
      const moneyTemplate = this.section.dataset.cartMoneyTemplate || '';
      const templatedMoney = this.formatMoneyFromTemplate(value, currency, moneyTemplate);
      if (templatedMoney) return templatedMoney;

      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
          currencyDisplay: 'narrowSymbol',
        }).format(value);
      } catch (error) {
        return `${currency} ${value.toFixed(2)}`;
      }
    }

    cartCurrencyCode() {
      return this.activeCartCurrency || this.section.dataset.cartCurrencyCode || window.Shopify?.currency?.active || 'USD';
    }

    formatMoneyFromTemplate(value, currency, template) {
      if (!template) return '';

      const symbol = this.currencySymbol(currency);
      if (!symbol || !template.includes(symbol)) return '';

      const decimalSeparator = this.templateDecimalSeparator(template);
      const amount = value.toFixed(2).replace('.', decimalSeparator);
      const firstDigit = template.search(/\d/);
      const symbolIndex = template.indexOf(symbol);

      return symbolIndex >= 0 && firstDigit >= 0 && symbolIndex < firstDigit
        ? `${symbol}${amount}`
        : `${amount} ${symbol}`;
    }

    currencySymbol(currency) {
      return {
        USD: '$',
        CAD: '$',
        AUD: '$',
        NZD: '$',
        SGD: '$',
        HKD: '$',
        EUR: '€',
        GBP: '£',
        JPY: '¥',
        CNY: '¥',
        KRW: '₩',
        ILS: '₪',
        INR: '₹',
      }[currency] || '';
    }

    templateDecimalSeparator(template) {
      const commaIndex = template.lastIndexOf(',');
      const dotIndex = template.lastIndexOf('.');
      return commaIndex > dotIndex ? ',' : '.';
    }

    syncCartCurrency(cart) {
      const previousCurrency = this.activeCartCurrency;
      if (cart?.currency) this.activeCartCurrency = cart.currency;
      this.syncCurrencyFromDrawer(document.querySelector('cart-drawer'));
      if (this.activeCartCurrency === cart?.currency && previousCurrency && previousCurrency !== cart.currency) {
        this.activeCartCurrency = previousCurrency;
      }
    }

    syncCurrencyFromDrawer(drawer = document.querySelector('cart-drawer')) {
      const footerText = drawer?.querySelector('.drawer__footer')?.textContent || '';
      this.syncCurrencyFromText(footerText || this.section.dataset.cartMoneyProbe || '');
    }

    syncCurrencyFromText(text) {
      const value = String(text || '').toUpperCase();
      if (value.includes('€')) this.activeCartCurrency = 'EUR';
      if (value.includes('£')) this.activeCartCurrency = 'GBP';
      if (value.includes('¥')) this.activeCartCurrency = 'JPY';

      const supportedCodes = [
        'USD', 'EUR', 'GBP', 'CAD', 'AUD', 'NZD', 'JPY', 'CHF', 'DKK', 'SEK', 'NOK',
        'PLN', 'CZK', 'HUF', 'RON', 'MXN', 'BRL', 'COP', 'CLP', 'PEN', 'SGD', 'HKD',
        'AED', 'SAR', 'ILS', 'KRW', 'MYR', 'THB', 'PHP', 'INR', 'ZAR',
      ];
      const explicitCode = supportedCodes.find((code) => new RegExp(`\\b${code}\\b`).test(value));
      if (explicitCode) this.activeCartCurrency = explicitCode;
    }

    cartLocale() {
      return this.section.dataset.cartLocale || document.documentElement.lang || navigator.language || 'en-US';
    }

    parseMoneyText(value) {
      const raw = String(value || '').trim();
      if (!raw) return null;

      const cleaned = raw.replace(/\s/g, '').replace(/[^\d,.-]/g, '');
      if (!/\d/.test(cleaned)) return null;

      const lastComma = cleaned.lastIndexOf(',');
      const lastDot = cleaned.lastIndexOf('.');
      const normalized = lastComma > lastDot
        ? cleaned.replace(/\./g, '').replace(',', '.')
        : cleaned.replace(/,/g, '');
      const amount = Number(normalized);

      return Number.isFinite(amount) ? amount : null;
    }

    formatAddonMoney(cents, text) {
      const numericCents = Number(cents || 0);
      if (numericCents > 0) return this.formatCartMoney(numericCents);

      const parsed = this.parseMoneyText(text);
      if (parsed !== null) return this.formatCartMoney(Math.round(parsed * 100));

      return this.escapeHtml(text || '');
    }

    escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, (character) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;',
      })[character]);
    }

    getSectionAttribute(name) {
      return this.section.getAttribute(name) || '';
    }

    getCartAddons() {
      return [1, 2, 3, 4, 5, 6, 7, 8, 9].map((index) => ({
        index,
        variantId: this.getSectionAttribute(`data-cart-addon-${index}-variant-id`),
        title: this.getSectionAttribute(`data-cart-addon-${index}-title`),
        price: this.getSectionAttribute(`data-cart-addon-${index}-price`),
        priceCents: this.getSectionAttribute(`data-cart-addon-${index}-price-cents`),
        compare: this.getSectionAttribute(`data-cart-addon-${index}-compare`),
        compareCents: this.getSectionAttribute(`data-cart-addon-${index}-compare-cents`),
        image: this.getSectionAttribute(`data-cart-addon-${index}-image`),
      })).filter((addon) => addon.title || addon.variantId || addon.image);
    }

    cartAddonsSignature() {
      return [this.cartCurrencyCode()].concat(this.getCartAddons().map((addon) => [
        addon.index,
        addon.variantId,
        addon.title,
        addon.price,
        addon.priceCents,
        addon.compare,
        addon.compareCents,
        addon.image,
      ].join('|'))).join('::');
    }

    scrollCartAddonPage(dot) {
      const cross = dot.closest('[data-kpx-cross-sell]');
      const track = cross?.querySelector('[data-kpx-addon-track]');
      if (!track) return;

      const page = Number(dot.dataset.page || 0);
      const visibleCards = Array.from(track.querySelectorAll('[data-kpx-addon-card]')).filter((card) => !card.hidden);
      const target = visibleCards[page * 3];
      if (target) {
        track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }

      cross.querySelectorAll('[data-kpx-addon-dot]').forEach((button, index) => {
        button.classList.toggle('is-active', index === page);
      });
    }

    cartAddonMarkup(addon) {
      const title = this.escapeHtml(addon.title || 'Recommended add-on');
      const price = this.formatAddonMoney(addon.priceCents, addon.price);
      const compare = this.formatAddonMoney(addon.compareCents, addon.compare);
      const imageMarkup = addon.image
        ? `<img src="${this.escapeHtml(addon.image)}" alt="${title}" loading="lazy">`
        : '<svg viewBox="0 0 24 24" fill="none"><path d="M7 10V8a5 5 0 0 1 10 0v2" stroke="currentColor" stroke-width="1.8"/><path d="M5 10h14v10H5V10Z" stroke="currentColor" stroke-width="1.8"/><path d="M12 14v3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
      const priceMarkup = price || compare
        ? `<div class="kpx-cart__addon-price-row">${price ? `<span class="kpx-cart__addon-price">${price}</span>` : ''}${compare ? `<span class="kpx-cart__addon-compare">${compare}</span>` : ''}</div>`
        : '';

      return `
        <div class="kpx-cart__addon" data-kpx-addon-card data-addon-index="${this.escapeHtml(addon.index)}" data-variant-id="${this.escapeHtml(addon.variantId)}">
          <div class="kpx-cart__addon-media" aria-hidden="true">${imageMarkup}</div>
          <strong>${title}</strong>
          ${priceMarkup}
          <button type="button" class="kpx-cart__add-button" data-kpx-cart-offer data-variant-id="${this.escapeHtml(addon.variantId)}" aria-label="Add ${title}" ${addon.variantId ? '' : 'disabled'}>+</button>
        </div>
      `;
    }

    updateCartAddons(cart) {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      const cross = drawer.querySelector('[data-kpx-cross-sell]');
      if (!cross) return;

      const track = cross.querySelector('[data-kpx-addon-track]');
      const cartVariantIds = new Set((cart?.items || []).map((item) => String(item.variant_id)));
      const packVariants = this.getPackVariants();
      const highestPackIndex = packVariants.reduce((highest, variant, index) => (
        cartVariantIds.has(String(variant.id)) && index > highest ? index : highest
      ), -1);
      const shouldShowIncludedAddons = highestPackIndex === 0;
      const cards = Array.from(cross.querySelectorAll('[data-kpx-addon-card]'));
      let visibleCount = 0;

      cards.forEach((card) => {
        const variantId = String(card.dataset.variantId || '');
        const addonIndex = Number(card.dataset.addonIndex || 0);
        const isIncludedInHigherPacks = addonIndex >= 1 && addonIndex <= 3;
        const alreadyInCart = variantId && cartVariantIds.has(variantId);
        const shouldHide = alreadyInCart || isIncludedInHigherPacks && !shouldShowIncludedAddons;
        card.hidden = shouldHide;
        if (!shouldHide) visibleCount += 1;
      });

      cross.hidden = visibleCount === 0;
      this.updateCartAddonDots(cross, visibleCount);

      if (track) {
        const firstVisibleCard = cards.find((card) => !card.hidden);
        const left = firstVisibleCard ? firstVisibleCard.offsetLeft - track.offsetLeft : 0;
        track.scrollTo({ left: Math.max(0, left), behavior: 'auto' });
      }
    }

    updateCartAddonDots(cross, visibleCount) {
      const dots = cross.querySelector('[data-kpx-addon-dots]');
      if (!dots) return;

      const pageCount = Math.max(1, Math.ceil(visibleCount / 3));
      dots.innerHTML = Array.from({ length: pageCount }).map((_, index) => (
        `<button type="button" data-kpx-addon-dot data-page="${index}" class="${index === 0 ? 'is-active' : ''}" aria-label="Show add-ons page ${index + 1}"></button>`
      )).join('');
      dots.hidden = pageCount <= 1;
    }

    cartDrawerModules(addonsSignature = this.cartAddonsSignature()) {
      const addonMarkup = this.getCartAddons().map((addon) => this.cartAddonMarkup(addon)).join('');
      const addonsHeading = this.escapeHtml(this.getSectionAttribute('data-cart-addons-heading') || 'Complete your setup');
      const homeUrl = this.escapeHtml(this.getSectionAttribute('data-home-url') || '/');
      const signature = this.escapeHtml(addonsSignature);

      return `
        <div class="kpx-cart__stack" data-addons-signature="${signature}">
          <div class="kpx-cart__confirm"><i aria-hidden="true"></i><span>Added to cart</span></div>
          <div class="kpx-cart__empty" data-kpx-cart-empty hidden>
            <strong>Your cart is empty</strong>
            <span>Add your Kronox pack to unlock the best offer.</span>
            <a class="kpx-cart__empty-button" href="${homeUrl}">Continue shopping</a>
          </div>
          <div class="kpx-cart__items" data-kpx-cart-items></div>

          <div class="kpx-cart__panel kpx-cart__upgrade" data-kpx-upgrade hidden>
            <div class="kpx-cart__upgrade-media" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none"><path d="M12 19V5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/><path d="m6.5 10.5 5.5-5.5 5.5 5.5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 19h14" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>
            </div>
            <div>
              <span class="kpx-cart__eyebrow">Recommended upgrade</span>
              <strong data-kpx-upgrade-title>Unlock a better pack</strong>
              <p data-kpx-upgrade-text>Get more value before checkout.</p>
              <div class="kpx-cart__upgrade-bottom">
                <span class="kpx-cart__upgrade-price" data-kpx-upgrade-price>Upgrade now</span>
                <button type="button" class="kpx-cart__upgrade-button" data-kpx-cart-offer data-kpx-pack-upgrade disabled>Upgrade</button>
              </div>
            </div>
          </div>

          <div class="kpx-cart__panel kpx-cart__progress" data-kpx-priority-progress>
            <strong data-kpx-priority-title>Priority processing progress</strong>
            <p data-kpx-priority-text>You are ${this.formatCartMoney(0)} away from free priority processing.</p>
            <div class="kpx-cart__bar" aria-hidden="true"><span data-kpx-priority-bar></span></div>
            <div class="kpx-cart__milestones">
              <span data-kpx-priority-milestone class="is-active">Added</span>
              <span data-kpx-priority-milestone>Priority</span>
              <span data-kpx-priority-milestone>Complete</span>
            </div>
          </div>

          <div class="kpx-cart__panel kpx-cart__cross" data-kpx-cross-sell ${addonMarkup ? '' : 'hidden'}>
            <div class="kpx-cart__cross-head">
              <span class="kpx-cart__cross-title">${addonsHeading}</span>
              <span class="kpx-cart__cross-dots" data-kpx-addon-dots></span>
            </div>
            <div class="kpx-cart__addons" data-kpx-addon-track>
              ${addonMarkup}
            </div>
          </div>

          <div class="kpx-cart__trust" aria-label="Cart trust benefits">
            <div class="kpx-cart__trust-item"><svg viewBox="0 0 24 24" fill="none"><path d="M12 3 5 6v5c0 4.4 2.8 8.4 7 10 4.2-1.6 7-5.6 7-10V6l-7-3Z" stroke="currentColor" stroke-width="1.8"/><path d="m8.8 12.1 2 2 4.4-5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg><span>45-Day Guarantee</span></div>
            <div class="kpx-cart__trust-item"><svg viewBox="0 0 24 24" fill="none"><path d="M3 7h11v9H3V7Zm11 3h4l3 3v3h-7v-6Z" stroke="currentColor" stroke-width="1.8"/><path d="M7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm11 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" stroke="currentColor" stroke-width="1.8"/></svg><span>Fast Shipping</span></div>
            <div class="kpx-cart__trust-item"><svg viewBox="0 0 24 24" fill="none"><path d="M7 10V8a5 5 0 0 1 10 0v2" stroke="currentColor" stroke-width="1.8"/><path d="M5 10h14v10H5V10Z" stroke="currentColor" stroke-width="1.8"/><path d="M12 14v3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg><span>Secure Checkout</span></div>
          </div>
        </div>
      `;
    }
  }

  document.querySelectorAll('[data-kpx-product]').forEach((section) => {
    if (!section.dataset.kpxReady) {
      section.dataset.kpxReady = 'true';
      new KronoxProductInfo(section);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
